import React, { useState } from "react";
import { CardActions, CardContent, Paper, Button, Stack, IconButton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import KanbanRatingDropdown from "./KanbanRatingDropdown";
import { ExpandMoreRounded, ExpandLessRounded } from "@material-ui/icons";
import KanbanCardProgress from "./KanbanCardProgress";
import KanbanCardCommentActions from "./KanbanCardCommentActions";
import Divider from '@mui/material/Divider';
import KanbanCardCommentSection from "./KanbanCardCommentSection";
import KanbanCardQuestionareSection from "./KanbanCardQuestionareSection";
import { useTranslation } from "react-i18next";


const KanbanCard = (props) => {

  const [commentsExpanded, setCommentsExpanded] = useState(false);
  const [questionareExpanded, setQuestionareExpanded] = useState(false);
  const { t } = useTranslation();

  const updateRating = (rating) => {
    props.updateCardRating(props.id, props.columnId, rating);
  }

  const toggleCommentsExpanded = () => {
    setCommentsExpanded(!commentsExpanded);
    setQuestionareExpanded(false);
  }

  const toggleQuestionareExpanded = () => {
    setQuestionareExpanded(!questionareExpanded);
    setCommentsExpanded(false);
  }

  return (
    <>
      <Paper
        id={props.id}
        key={props.id + props.isCardSelected}
        className={"kanban is-card " + ((!props.isCardVisible) ? ('is-rated is-rated-' + props.rating) : '') + ' ' + (props.isCardSelected ? 'is-selected' : '')}
        onClick={(e) => {
          e.stopPropagation();
          props.toggleSelectedCard(props.id);
        }}
      >

        <>
          {((props.isCardVisible && props.columnId > 0) || (props.openQuestionableColumn && props.columnId == 0)) && (
            <>
              <CardContent style={{ paddingTop: '0px !important' }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                  <div style={{ fontSize: '14px', fontWeight: '800' }}>
                    {props.fullName}
                  </div>
                  <Tooltip title={t("kanban.comments.toggleQuestionare")}>
                    <IconButton size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleQuestionareExpanded();

                      }}
                    >
                      {!questionareExpanded && (
                        <ExpandMoreRounded className="color color-black" />
                      )}
                      {questionareExpanded && (
                        <ExpandLessRounded className="color color-black" />
                      )}
                    </IconButton>
                  </Tooltip>
                </div>
                <Stack>
                  {(props.columnId > 1 || props.columnId < 1) && (
                    <>
                      <span style={{ fontSize: '12px' }}>
                        {props.email}
                      </span>
                      <span style={{ fontSize: '12px', fontWeight: '600' }}>
                        {props.phone}
                      </span>
                      <span style={{ fontSize: '12px' }}>
                        {props.location}
                      </span>
                    </>
                  )}
                  {props.columnId > 0 && (
                    <KanbanRatingDropdown rating={props.rating} updateRating={updateRating} />
                  )}
                  {props.columnId == 0 && (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent:"right" }}>
                      <Button
                        variant="filled"
                        disableElevation
                        disabled={props.emailSent}
                        className="bg color color-white bg-medium-red"
                        type="submit"
                        size="small"
                        style={{ borderRadius: '10px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          props.handleReject(props.id);
                        }}
                      >
                      {t("kanban.reject")}
                      </Button>
                    </div>
                  )}
                </Stack>
              </CardContent>
              <Divider light />
                {(props.columnId >= 1 && props.columnId <= 3) && (
                  <>
                    <CardActions>
                      <KanbanCardProgress createdAt={props.createdAt} />
                    </CardActions>
                    <Divider light />
                  </>
                )}
              <CardActions>
                  <KanbanCardCommentActions
                    toggleExpanded={toggleCommentsExpanded}
                    numberOfComments={props.comments.length}
                    openCommentDialog={props.openKanbanCommentDialog}
                    cardId={props.id}
                    columnId={props.columnId}
                  />
                
              </CardActions>
              {commentsExpanded && (
                <>
                  <Divider light />
                  <CardContent>
                    <KanbanCardCommentSection 
                      comments={props.comments}
                      cardId={props.id}
                      columnId={props.columnId}
                      editComment={props.editComment}
                      deleteComment={props.deleteComment} />
                  </CardContent>
                </>
              )}
              {questionareExpanded && (
                <>
                  <Divider light />
                  <CardContent>
                    <KanbanCardQuestionareSection segments={props.segments} />
                  </CardContent>
                </>
              )}
            </>
          )}
        </>
      </Paper>

    </>
  );
}

KanbanCard.propTypes = {
  id: PropTypes.string,
  fullName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  emailSent: PropTypes.bool,
  location: PropTypes.string,
  rating: PropTypes.number,
  city: PropTypes.string,
  createdAt: PropTypes.string,
  updateCardRating: PropTypes.func,
  kanbanCommentDialogOpen: PropTypes.bool,
  openKanbanCommentDialog: PropTypes.func,
  setKanbanCommentCardId: PropTypes.func,
  closeKanbanCommentDialog: PropTypes.func,
  saveCardComment: PropTypes.func,
  isCardVisible: PropTypes.bool,
  columnId: PropTypes.number,
  comments: PropTypes.array,
  segments: PropTypes.array,
  toggleSelectedCard: PropTypes.func,
  isCardSelected: PropTypes.bool,
  openQuestionableColumn: PropTypes.bool,
  isUserAdmin: PropTypes.bool,
  editComment: PropTypes.func,
  deleteComment: PropTypes.func,
  handleReject: PropTypes.func
};

export default KanbanCard;